import { useState } from 'react';
import { ITicket } from '../types/Ticket/ITicket';
import { ISetStatusProps } from '../types/Ticket/Status/ISetStatusProps';
import { IUserProfile } from '../types/User/IUserProfile';
import { TicketApi } from '../redux/api/TicketApi';
import { GroupAssignedProps } from '../components/Ticket/TicketDetails/Sections/Tools/Close/GroupAssigned';
import useRedirectOnClose from './useRedirectOnClose';
import { useNavigate } from 'react-router-dom';
import { useCloseDialog } from '../components/Ticket/TicketDetails/Sections/Tools/Close/CloseDialogContext';
import { set, update } from 'lodash';
import { useSelector } from 'react-redux';
import { useReduxDispatch, useReduxSelector } from '../redux/hooks';
import { setIsClosing } from '../slices/TicketDetailSlice';

interface UseCloseTicketLogicReturn {
    closeTicket: (ticket: ITicket, closeStatusId?: number) => void;
    isClosing: boolean;
    error: string | null;
}

export const useCloseTicketLogic = (profile: IUserProfile): UseCloseTicketLogicReturn => {
    const { isClosing } = useReduxSelector(s => s.ticketDetails);
    const updateState = useReduxDispatch();
    //const [isClosing2, setIsClosing] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [setAssigned, { isLoading: settingOwnership }] = TicketApi.useReassignMutation();
    const [setStatus, { isLoading }] = TicketApi.useSetStatusMutation();
    //const [configGroupProps, setConfirmDialogProps] = useState<GroupAssignedProps>(null);
    const handleRedirect = useRedirectOnClose();
    const { data: allStatuses } = TicketApi.useGetStatusesQuery();
    const defaultCloseStatus = allStatuses?.find(s => s.Closed_default === true);
    const navigate = useNavigate();
    const { showDialog, hideDialog } = useCloseDialog();


    //Close the current ticket and assign the specified status id
    const closeTicket = (ticket: ITicket, statusId?: number) => {
        console.log('profile.Features.Require_Ticket_Ownership_To_Close', profile.Features.Require_Ticket_Ownership_To_Close, ticket.Call_Assignment);

        //Check if the ticket is assigned only to a queue - need to show a dialog to confirm assignment to the current user
        if (ticket.Call_Assignment.length === 1 && ticket.Call_Assignment[0].Access_Level_Id === 6) {
            showDialog({
                show: true, onClose: (yes) => {
                    //Assign to ME
                    if (yes) {
                        setAssigned({ TicketId: ticket.ID, New_Assignees: [profile?.Id] }).unwrap().then(() => {
                            //Close 
                            //setConfirmDialogProps(p => { return { ...p, show: false } })
                            hideDialog();
                            continueClose({ ...ticket, CloseValidationCodes: ticket.CloseValidationCodes?.filter(c => c !== -7) }, statusId);
                        });
                    } else {
                        hideDialog();
                    }
                }
            });
            return
        } else {
            //Require Ownership to close FEATURE
            if (profile.Features.Require_Ticket_Ownership_To_Close && ticket.Call_Assignment.find(a => a.Contact_Id === profile.Id) === undefined) {
                showDialog({
                    message: `${profile?.Phrases.CallPhrase} ownership is required. Would you like to assign the ${profile?.Phrases.CallPhrase} to yourself before closing it?`,
                    show: true, onClose: (yes) => {
                        //Assign to ME
                        if (yes) {
                            setAssigned({ TicketId: ticket.ID, New_Assignees: [profile?.Id] }).unwrap().then(() => {
                                //Close 
                                hideDialog();

                                continueClose({ ...ticket, CloseValidationCodes: ticket.CloseValidationCodes?.filter(c => c !== -7) }, statusId);
                            });
                        } else {
                            hideDialog();
                        }
                    }
                });
                return
            }
        }

        continueClose(ticket, statusId);
    }

    const continueClose = (ticket: ITicket, statusId?: number) => {
        console.log('continueClose', ticket, statusId);
        //if there is no close validation then just close the ticekt otherwise navigate to the close page
        if (ticket.CloseValidationCodes.length === 0) {
            updateState(setIsClosing(true));

            //DefaULT CLOSE
            setStatus({
                Ticket_Id: ticket.ID,
                New_Status_Id: statusId || defaultCloseStatus?.ID
            } as ISetStatusProps).unwrap().then(() => {
                updateState(setIsClosing(false));

                //Close the ticket
                handleRedirect(ticket?.ID);

                setError('Testing');
            }).catch((err) => {
                updateState(setIsClosing(false));

                //if the api returns a 400 error them open the validation popup
                if (err.originalStatus === 400) {
                    navigate(`close/${statusId}`);
                }
            });

            return false;
        }

        navigate(`close/${statusId || ''}`);
    }

    return { closeTicket, isClosing, error };
};

